// Confronto di versioni semver "x.y.z" (= versionName/MARKETING_VERSION delle app).
// compareVersions ritorna 1 se a>b, -1 se a<b, 0 se uguali. Parti mancanti = 0.
export const compareVersions = (a, b) => {
    const pa = String(a || '').split('.').map(n => parseInt(n, 10) || 0);
    const pb = String(b || '').split('.').map(n => parseInt(n, 10) || 0);
    const len = Math.max(pa.length, pb.length);
    for (let i = 0; i < len; i++) {
        const x = pa[i] || 0;
        const y = pb[i] || 0;
        if (x > y) return 1;
        if (x < y) return -1;
    }
    return 0;
};

// true se la versione installata è inferiore al target (→ aggiornamento disponibile/necessario)
export const isVersionLower = (installed, target) => compareVersions(installed, target) < 0;
